import classNames from 'clsx'
import {
  arrayOf,
  bool,
  node,
  number,
  object,
  oneOfType,
  shape,
  string,
} from 'prop-types'

import './Tabs.scss'

const Tabs = ({ items, tabId, noContentPadding }) => {
  if (!items?.length > 0) {
    return null
  }

  const tabContentClass = classNames(
    'o-Tabs__content u-border-radius--bottom-right u-border-radius--bottom-left u-border--bottom u-border--left u-border--right',
    {
      'u-padding-large': !noContentPadding,
    }
  )

  return (
    <div data-clientside-hook="tabs" data-tab-id={tabId}>
      <div className="o-Tabs__header l-flex l-flex--distribute-space u-border-radius--top-right u-border-radius--top-left u-background-color--greySky u-font-weight--bold u-color--blue">
        {items.map((item, index) => {
          const itemClass = classNames(
            'o-Tabs__tab l-flex__half-width@medium u-border--bottom l-flex__primary u-padding u-border-radius--top-right u-border-radius--top-left u-text-align--center',
            {
              'o-Tabs__tab--active': index === 0,
            }
          )

          return (
            <div
              key={index}
              className={itemClass}
              data-clientside-hook={`tabsHeader ${item.clientSideHook || ''}`}
              data-tab-id={tabId}
              data-index={index}
            >
              {item.title}
            </div>
          )
        })}
      </div>
      <div className={tabContentClass}>
        {items.map((item, index) => (
          <div
            key={index}
            data-clientside-hook="tabsContent"
            data-index={index}
            data-tab-id={tabId}
            className="o-Tabs__content-item"
            aria-hidden={index === 0 ? null : true}
          >
            {item.content}
          </div>
        ))}
      </div>
    </div>
  )
}

Tabs.propTypes = {
  items: arrayOf(
    shape({
      title: oneOfType([string, object]).isRequired,
      content: node.isRequired,
    })
  ).isRequired,
  tabId: oneOfType([string, number]).isRequired,
  noContentPadding: bool,
}

export default Tabs
